
export const homeObjOne = {
id:'about',
lightBg:true,
lightText:false,
darkText:true,
// lightTextDesc:false,
to:'projects',
topLine:'Who am i?',
headLine:'My name is elad barzilay ',
description:`
32 years old and from Israel. Full-stack developer with passion to explore and learn new things every day.
  Programming has been an interest of mine for many
  years. In my free time I love traveling, climbing and play tennis.
   I'm looking for my next challenge to take my programming skills to another level. `,
buttonLable:'See my work',
imgStart:false,
img:require('../../assests/images/mylang.png'),
alt:'mylanguges',
dark:false,
primary:false,

}

export const homeObjTwo = {
    id:'contact',
    lightBg:true,
    lightText:false,
    darkText:true,
    to:'home',
    topLine:'Contact Information',
    headLine:"",
    description:`eladbarzilay53@gmail.com`,
    description1:`0524588853`,
    buttonLable:'Go to top',
    imgStart:false,
    img:require('../../assests/images/contactUs.jpg'),
    alt:'Car',
    dark:false,
    primary:false
    
    }

    // export const homeObjThree = {
    //     id:'contact',
    //     lightBg:false,
    //     lightText:true,
    //     lightTextDesc:false,
    //     topLine:'premium',
    //     headLine:'dgjdflgjdfjgj',
    //     description:'fdfsdfsfdsfsdfsfsfsfsdfsfs  dfsdf sfs sfs sfs fds',
    //     buttonLable:'get started',
    //     imgStart:false,
    //     img:require('../../assests/images/img1.png'),
    //     alt:'Car',
    //     dark:true,
    //     primary:true,
    //     darkText:false
        
    //     }